import React, { useCallback } from 'react'

import ModalBase from 'LuxKit/Modal/ModalBase'
import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalFooter from 'LuxKit/Modal/ModalFooter'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import noop from 'lib/function/noop'

interface Props {
  variation: 'trip' | 'leTripItem' | 'customTripItem' | 'exploreItem'
  onConfirmAddDates?: () => void
}

export function AddToItineraryDatesRequiredModal({
  variation,
  onConfirmAddDates = noop,
}: Props) {
  const modalElement = useModalElementContext<boolean>()
  const onClickAddDates = useCallback(() => {
    modalElement?.resolve(true)
    onConfirmAddDates()
  }, [modalElement, onConfirmAddDates])

  const onClickCancel = useCallback(() => {
    modalElement?.resolve(false)
  }, [modalElement])

  let detailText: string
  switch (variation) {
    case 'trip':
      detailText =
        'You need to add dates to your trip before you can add items to your itinerary.'
      break
    case 'leTripItem':
      detailText =
        'To include this item in your itinerary, enter your preferred dates on the offer page. These dates will then be saved with your offer.'
      break
    case 'customTripItem':
      detailText =
        'To include this item in your itinerary, add your preferred dates. These dates will then be saved with your item.'
      break
    case 'exploreItem':
      detailText =
        'You currently don’t have dates for your trip. Add dates to your trip settings to start building your itinerary and saving attractions.'
      break
  }

  return (
    <ModalBase>
      <ModalHeader title="Move to" />
      <ModalBody>
        <ModalContent>
          <BodyTextBlock variant="large">{detailText}</BodyTextBlock>
        </ModalContent>
      </ModalBody>
      <ModalFooter
        primaryActionProps={{
          children: 'Add dates',
          onClick: onClickAddDates,
        }}
        secondaryActionProps={{
          children: 'Cancel',
          onClick: onClickCancel,
        }}
      />
    </ModalBase>
  )
}
